// RAHO Club Premier - New Structure Mock Data

export const heroData = {
  title: 'RAHO CLUB PREMIER',
  subtitle: 'Harapan bagi umat manusia',
  description: 'Raho Club Premier adalah ekosistem layanan riset kesehatan premium berbasis bioteknologi molekuler, nano bubble therapy, dan gasotransmitter science untuk membantu tubuh melakukan pemulihan, regenerasi, dan aging sehat secara alami.',
  tagline: 'Kami bekerja di akar masalah, bukan hanya gejala. Sampai tingkat sel.'
};

export const challengeData = {
  title: 'Terobosan tercanggih untuk penanganan penyakit degeneratif dan sulit disembuhkan',
  subtitle: 'Masyarakat modern menghadapi tantangan:',
  challenges: [
    'Penyakit kronis & degeneratif meningkat',
    'Terapi farmakologis sering bersifat simptomatik',
    'Mikrosirkulasi & hipoksia sel jarang disentuh'
  ],
  solutionIntro: 'Raho Club Premier hadir sebagai pendekatan komplementer berbasis sains, fokus pada:',
  solutions: [
    'Optimalisasi oksigenasi',
    'Mikrosirkulasi',
    'Regulasi sinyal biologis (gasotransmitter)',
    'Dukungan regenerasi sel & jaringan'
  ]
};

export const scientificData = {
  title: 'Scientific Foundation',
  subtitle: 'Core Platform',
  platforms: [
    {
      id: 1,
      name: 'Nano Bubble System (NBS)',
      description: 'Teknologi penghantaran gas terlarut berukuran nano untuk penetrasi optimal pada sistem vaskular mikro.',
      icon: 'Microscope'
    },
    {
      id: 2,
      name: 'Gasotransmitter-Based Therapy',
      description: 'Pemanfaatan gas biologis (CO, NO, H₂S) sebagai cellular signaling modulator.',
      icon: 'FlaskConical'
    },
    {
      id: 3,
      name: 'Microcirculation Optimization Model',
      description: 'Fokus membuka kapiler non-perfused → meningkatkan delivery oksigen & nutrisi.',
      icon: 'Activity'
    }
  ],
  applicationsTitle: 'Potensi aplikasi pada:',
  applications: [
    'Penyakit metabolik',
    'Autoimun & inflamasi kronis',
    'Neurologi & pemulihan pasca stroke',
    'Oncology supportive care',
    'Fatigue kronis & sindrom metabolik',
    'Wellness dan Reverse Aging'
  ]
};

export const partnershipData = {
  title: 'Clinical Partnership, Research-Based, for Health & Wellness Platform',
  subtitle: 'Model Kolaborasi',
  forDoctors: {
    title: 'Untuk Dokter',
    icon: 'Stethoscope',
    items: [
      'Co-management pasien',
      'Protokol terapi pendukung',
      'Edukasi & scientific discussion forum',
      'Riset berbasis komunitas & data klinis'
    ]
  },
  forInstitutions: {
    title: 'Untuk Klinik, Rumah Sakit & Institusi',
    icon: 'Building2',
    items: [
      'Integrasi layanan Raho Premier',
      'Pengembangan wellness center atau health center bersama'
    ]
  }
};

export const governanceData = {
  title: 'Standar & Governance',
  items: [
    'Protokol berbasis SOP medis & etika klinis',
    'Non-farmakologis, tanpa efek samping',
    'Pendekatan evidence-informed & transparent',
    'Tidak menggantikan terapi medis konvensional'
  ]
};

export const visionData = {
  title: 'Visi Bersama',
  description: 'Membangun ekosistem kesehatan molekuler dan longevity berbasis komunitas, riset, dan kolaborasi klinis.',
  subtitle: 'Raho Premier membuka ruang bagi dokter dan institusi yang ingin:',
  points: [
    'Berpikir progresif',
    'Mengembangkan praktik berbasis sains masa depan',
    'Berkontribusi dalam transformasi layanan kesehatan'
  ]
};

export const ctaData = {
  title: 'Mari Berkolaborasi',
  description: 'Diskusikan potensi kerja sama, model klinis, dan pengembangan layanan bersama.',
  location: 'Jakarta',
  contactLabel: 'Partnership & Medical Collaboration',
  buttons: [
    {
      label: 'Schedule Scientific Discussion',
      whatsapp: 'https://wa.me/6285136222772',
      type: 'primary'
    },
    {
      label: 'Become a Research Partner',
      whatsapp: 'https://wa.me/6281806977029',
      type: 'secondary'
    }
  ]
};

export const stats = [
  { value: '22.000', suffix: '+', label: 'Nara Coba' },
  { value: '90', suffix: '+', label: 'Research Partner' },
  { value: '15', suffix: '', label: 'Kota' }
];

export const locations = [
  {
    id: 1,
    city: 'Jakarta Selatan',
    region: 'DKI Jakarta',
    name: 'Attya Reverse Aging',
    address: 'Jl. Langsat IV No.9, RT.3/RW.1, Kramat Pela, Kec. Kby. Baru, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12130'
  },
  {
    id: 2,
    city: 'Jakarta Utara',
    region: 'DKI Jakarta',
    name: 'Klinik Utama O2',
    address: 'Exclusive Bukit Golf Mediterania, Jl. Rukan No.76 blok g, RT.7/RW.2, Kamal Muara, Penjaringan, North Jakarta City, Jakarta 14470'
  },
  {
    id: 3,
    city: 'Jakarta Pusat',
    region: 'DKI Jakarta',
    name: 'RAHO Club Premier Jakarta',
    address: 'Komplek Duta Merlin E no. 5-6, Petojo Utara, Kecamatan Gambir, Kota Jakarta Pusat, Daerah Khusus Ibukota Jakarta 10130'
  },
  {
    id: 4,
    city: 'Jakarta Pusat',
    region: 'DKI Jakarta',
    name: 'Raho Club Premier Menara Batavia',
    address: 'Jl. K.H. Mas Mansyur No.Kav. 126, Karet Tengsin, Kecamatan Tanah Abang, Kota Jakarta Pusat, Daerah Khusus Ibukota Jakarta 10250'
  },
  {
    id: 5,
    city: 'Bandung',
    region: 'Jawa Barat',
    name: 'Raho Premier Bandung',
    address: 'Jl. L. L. R.E. Martadinata No.166, Merdeka, Kec. Sumur Bandung, Kota Bandung, Jawa Barat 40113'
  },
  {
    id: 6,
    city: 'Bali',
    region: 'Bali',
    name: 'Apotek Hannah',
    address: 'Jl Gatot Subroto Barat no 18 a-b Kerobokan Kaja, Kuta Utara, Kab Badung, Provinsi Bali'
  },
  {
    id: 7,
    city: 'Semarang',
    region: 'Jawa Tengah',
    name: 'Attya Reverse Aging',
    address: 'Jl. Tumpang Raya no.48, Kel. Gajahmungkur, Kec. Gajahmungkur, Kota Semarang, Jawa Tengah'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Irjen. Pol. (Purn.) Drs. Hadiatmoko, S.H.',
    condition: 'Stroke',
    quote: 'Saya menderita penyakit stroke dan kini telah sembuh setelah menjalani 25x terapi nano bubble di RAHO-Club.',
    image: '../images/testi_hadi.webp'
  },
  {
    id: 2,
    name: 'Juwita Tri Yanti',
    condition: 'Kanker Tiroid',
    quote: 'Dokter telah mendiagnosa bahwa hidup saya tinggal beberapa bulan lagi. Namun, berkat terapi di RAHO-Club, saya berhasil mengalami perbaikan total dari kanker tiroid.',
    image: '../images/testi_juwita.webp'
  },
  {
    id: 3,
    name: 'Gunawan Soegianto',
    condition: 'Kanker Hati',
    quote: 'Setelah menjalani 15 sesi fast track terapi infus nano bubble di RAHO-Club, saya melakukan pemeriksaan ulang. Hasilnya sungguh luar biasa, dokter menyatakan bahwa kanker hati ganas yang saya derita kini sudah tidak aktif.',
    image: '../images/testi_gunawan.webp'
  },
  {
    id: 4,
    name: 'Maria Veronica',
    condition: 'Kanker Kolon',
    quote: 'Februari 2023, saya didiagnosa kanker kolon stadium 2A. Menolak kemoterapi, saya memilih terapi nano bubble di RAHO-Club. Hasilnya luar biasa—penyembuhan saya membaik dan saya merasa lebih sehat.',
    image: '../images/testi_maria_veronica.png'
  }
];

export const contactInfo = {
  whatsapp: '0851-3622-2772',
  whatsappLink: 'https://wa.me/6285136222772',
  partnerWhatsapp: '0818-0697-7029',
  partnerWhatsappLink: 'https://wa.me/6281806977029',
  imiWebsite: 'https://molecularinnovation.id/'
};
